export const NEWSLETTER_PROVIDERS = {
  klaviyo: {
    subscribe: async (
      email: string,
      companyId: string,
      listId: string,
      locationTitle: string
    ): Promise<boolean> => {
      try {
        if (!email) throw new Error("Email required for sign-up");
        if (!companyId)
          throw new Error("Company ID missing from Klaviyo configuration");
        if (!listId)
          throw new Error("List ID missing from Klaviyo configuration");
        if (!locationTitle)
          throw new Error("Location Title missing from Klaviyo configuration");

        const BASE_URL = "https://a.klaviyo.com/client/subscriptions";
        const endpoint = new URL(BASE_URL);
        endpoint.searchParams.set("company_id", companyId);

        const timestamp = new Date().toISOString();

        const body = JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    location: {
                      timezone: "Europe/Copenhagen",
                    },
                    properties: {
                      TT_CompanyRef: locationTitle,
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED",
                          consented_at: timestamp,
                        },
                      },
                    },
                    email: email,
                  },
                },
              },
              custom_source: "TableTaxi",
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId,
                },
              },
            },
          },
        });

        const options = {
          method: "POST",
          headers: {
            revision: "2024-10-15.pre",
            "content-type": "application/vnd.api+json",
          },
          body,
        };

        const response = await fetch(endpoint.toString(), options);

        if (!response.ok) {
          throw new Error(response.statusText);
        }

        const data = await response.json();

        console.log(data);

        return response.ok;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};
